import Vue from 'vue'
import Router from 'vue-router'

import i18n from '@/i18n'
import routes from './routes/index'
import store from '@/store'
import { scrollTo, scrollToTop } from '@/helpers/utils'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  fallback: false
})

router.beforeEach((to, from, next) => {
  if (to.meta.name === from.meta.name) {
    return next()
  }

  let delay = 0
  if (store.getters.hasOverlays) {
    store.dispatch('hideOverlays')
    delay += 250
  }

  setTimeout(() => {
    scrollToTop(next)
  }, delay)
})

router.afterEach((to, from) => {
  if (!to.hash) {
    return
  }

  let delay = 0
  if (to.name !== from.name) {
    delay = 1000
  }

  setTimeout(() => {
    const $target = document.querySelector(to.hash)

    let offset = window.innerHeight / 3

    if ($target.clientHeight <= (window.innerHeight - offset)) {
      offset = (window.innerHeight - $target.clientHeight) / 2
    }

    scrollTo($target, -offset)
  }, delay)
})

export default router

export function localise (from, locale) {
  let to = from.path.split('/')

  if (i18n.fallbackLocale === locale) {
    to.splice(2, 1)
  } else if (i18n.fallbackLocale === from.meta.locale) {
    to.splice(2, 0, locale)
  } else {
    to[2] = locale
  }

  return to.join('/')
}



// WEBPACK FOOTER //
// ./src/router/index.js